// extracted by mini-css-extract-plugin
export var dashboardLink = "QuestionForm-module--dashboardLink--YSpCV";
export var emptyTextError = "QuestionForm-module--emptyTextError--qWu9j";
export var primary = "#06004d";
export var questionError = "QuestionForm-module--questionError--Evu46";
export var secondary = "#4dafd7";